// extracted by mini-css-extract-plugin
export default {"previewTable":"ReportConsolidadoMensualPreview_previewTable__RO3Xm"};